<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import IndividualHeader from '@/modules/investing/components/individual-header.vue'
import IndividualNav from '@/modules/investing/components/individual-nav-v2.vue'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import DocumentsList from '../components/documents-list.vue'
import { useIndividualStore } from '@/modules/investing/stores/better-individual-store'

const { individual_id, slug } = useRoute().params as { individual_id: string; slug: string }
const individualStore = useIndividualStore()

onMounted(async () => {
  await individualStore.fetchIndividual(individual_id, { slug })
})
</script>

<template>
  <TheLayout>
    <IndividualHeader />
    <IndividualNav selectedTab="esignatures" />
    <DocumentsList investor_type="individual" :investor_id="individual_id" />
  </TheLayout>
</template>
